import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-sandwitch-menu',
    templateUrl: './sandwitch-menu.component.html',
    styleUrls: ['./sandwitch-menu.component.scss'],
    standalone: false
})
export class SandwitchMenuComponent {
}
